/*
  2026-08-21 · Anirudh · scroll reveal for the about-* sections on /pages/about-us.

  Lives in an asset rather than inline in snippets/about-tokens.liquid because that snippet is
  rendered once per section, so the eight about-* sections were shipping eight copies of this
  source inline, about 20KB, on a store that already has a measured JS-weight problem. As an
  asset it is fetched once and cached, and the guard below means the eight script tags execute
  it once.

  THE DEFAULT STATE IS VISIBLE. This file opts INTO hiding by putting .about-reveal-ready on <html>, and
  only after it has confirmed it can run. If this file 404s, fails to parse, or the visitor has
  JavaScript off, nothing is ever hidden and the page reads as static content. Never invert
  that: hiding in CSS and revealing in script means any script failure is a blank page.
*/
(function () {
  if (window.__aboutReveal) { window.__aboutReveal(); return; }

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Bail before touching the DOM if we cannot do this safely. Nothing gets hidden, the page
  // simply renders as static content, which is the correct outcome and not a degraded one.
  if (reduce || !('IntersectionObserver' in window) || !root.classList) { return; }

  root.classList.add('about-reveal-ready');

  function show(el) { el.classList.add('about-revealed'); }

  // Both axes. Testing only the vertical one reported every card in a horizontal scroll rail
  // as "in view" the moment the rail's band appeared, which revealed all five timeline eras
  // at once and threw away the stagger on the horizontal layout.
  function inView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    var vw = window.innerWidth || 0;
    return r.top < vh * 0.94 && r.bottom > 0 && r.left < vw && r.right > 0;
  }

  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      show(e.target);
      obs.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  // Second path, for the case the observer is throttled or silently never fires (a
  // backgrounded tab does exactly this). Passive, rAF-coalesced, and it takes itself off the
  // event the moment nothing is left hidden, so it costs nothing once the page settles.
  var ticking = false;
  function sweep() {
    ticking = false;
    var left = document.querySelectorAll('[data-about-reveal]:not(.about-revealed)');
    for (var i = 0; i < left.length; i++) { if (inView(left[i])) show(left[i]); }
    if (!document.querySelector('[data-about-reveal]:not(.about-revealed)')) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(sweep);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  function scan() {
    var items = document.querySelectorAll('[data-about-reveal]:not(.about-revealed)');
    for (var i = 0; i < items.length; i++) { io.observe(items[i]); }
    // Anything already on screen at load reveals now rather than waiting for a scroll.
    sweep();
  }

  window.__aboutReveal = scan;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);

  // A tab opened in the background (cmd+click, session restore) has requestAnimationFrame and
  // IntersectionObserver callbacks frozen by the browser, so nothing reveals until it is
  // looked at. Verified on staging 21 Aug: visibilityState "hidden", rAF never fired, 0 of 30
  // revealed, and a full pass calling the sweep directly revealed all 30.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { scan(); }
  });
})();
